// extracted by mini-css-extract-plugin
module.exports = {"column":"column--l7R2z"};